import { useLayoutEffect, useState } from "react";

const TOP_BANNER_SLOT_ID = "top-banner";

/**
 * Height of the app-wide banners (e.g. "your privacy email has been disconnected") fixed over the top of the page, so
 * sticky content can sit below them instead of underneath.
 */
export const useTopBannerHeight = (): number => {
  const [height, setHeight] = useState(0);

  useLayoutEffect(() => {
    const slot = document.getElementById(TOP_BANNER_SLOT_ID);
    if (!slot) {
      return;
    }

    // Banners are absolutely positioned on top of each other inside the slot, so the tallest one is what covers the page.
    const measure = () =>
      setHeight(
        Math.ceil(
          Math.max(
            0,
            ...Array.from(slot.children, (child) => child.getBoundingClientRect().height),
          ),
        ),
      );

    const resizeObserver = new ResizeObserver(measure);
    const observeBanners = () => {
      resizeObserver.disconnect();
      resizeObserver.observe(slot);
      Array.from(slot.children).forEach((child) => resizeObserver.observe(child));
      measure();
    };

    const mutationObserver = new MutationObserver(observeBanners);
    mutationObserver.observe(slot, { childList: true });
    observeBanners();

    return () => {
      mutationObserver.disconnect();
      resizeObserver.disconnect();
    };
  }, []);

  return height;
};
